import { render } from "./Events.vue?vue&type=template&id=75b03864&scoped=true"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"

import "./Events.vue?vue&type=style&index=0&id=75b03864&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-75b03864"

export default script